/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as action from './action'
import { fetchRegionList } from '../ClubUsers/action'
import Deploy from './component/deploy'
import { Spin } from 'antd'

const actions = {
  ...action,
  fetchRegionList,
}
class ClubDeploy extends React.Component {
  static defaultProps = {
    deployList: [],
    deployInfo: {},
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    this.props.fetchClubDeployList().then((res) => {
      this.setState({ loading: false })
    })
    if (!this.props.regionList) this.props.fetchRegionList()
  }

  render() {
    const { deployList, deployInfo, regionList } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Deploy
            deployList={deployList}
            deployInfo={deployInfo}
            regionList={regionList}
            fetchGetAccount={this.props.fetchGetAccount}
            fetchSettingDeploy={this.props.fetchSettingDeploy}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    deployList: state.getClubDeploy.deployList,
    deployInfo: state.getClubDeploy.deployInfo,
    regionList: state.getClubUsers.regionList,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubDeploy))



// WEBPACK FOOTER //
// ./src/containers/ClubDeploy/index.js